import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormsModule, NgForm, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationnDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { AlertService } from '../../service/alert.service';
import { InternshipsService } from '../../service/internships.service';
import { CompanyService } from '../../service/company.service';
import { CountryDto, CityDto } from '../../models/company.model';
import { MatIcon } from "@angular/material/icon";
import { CommonModule } from '@angular/common';
import { AlertMessageComponent } from "../../shared/alert-message/alert-message.component";
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-create-available-internship-dialog',
  standalone: true,
  templateUrl: './create-available-internship-dialog.component.html',
  styleUrl: './create-available-internship-dialog.component.css',
  imports: [
    MatIcon,
    MatFormFieldModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    AlertMessageComponent,
    TranslateModule
  ]
})
export class CreateAvailableInternshipDialogComponent implements OnInit {

  countries: CountryDto[] = [];
  filteredCities: CityDto[] = [];
  selectedCountry: CountryDto | null = null;
  selectedCity: CityDto | null = null;
  citySearch: string = '';
  limitDescription = 600;
  description: string = '';
  email: string = '';

  constructor(private dialogRef: MatDialogRef<CreateAvailableInternshipDialogComponent>,private http: HttpClient,
              private dialog: MatDialog, private alertService:AlertService, private companyService: CompanyService,
              private translate: TranslateService) {}

  ngOnInit(): void {
    this.companyService.getCountries().subscribe({
      next: (data) => this.countries = data,
      error: (err) => console.error('Errore caricamento paesi:', err)
    });
  }

  compareCountries(c1: CountryDto, c2: CountryDto): boolean {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }

  compareCities(c1: CityDto, c2: CityDto): boolean {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }

  onCountryChange(): void {
    this.selectedCity = null;
    this.citySearch = '';
    this.filteredCities = [];
  }

  onCityInput(value: string): void {
    if (!this.selectedCountry) {
      this.filteredCities = [];
      return;
    }

    const countryId = this.selectedCountry.id;
    const search = (value || '').trim();

    if (!search) {
      this.filteredCities = [];
      return;
    }

    this.companyService.getCitiesSearch(countryId, search).subscribe({
      next: (data) => {
        this.filteredCities = data;
      },
      error: (err) => {
        console.error('City search error', err);
        this.filteredCities = [];
      }
    });
  }

  onCitySelected(city: CityDto): void {
    this.selectedCity = city;
    this.citySearch = city.name;
  }

  displayCityFn(item: any): string {
    if (!item) return '';
    return typeof item === 'string' ? item : item.name;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  autoResizeTextarea(event: any): void {
    const textarea = event.target as HTMLTextAreaElement;
    textarea.style.height = 'auto';
    textarea.style.height = Math.min(textarea.scrollHeight, 300) + 'px';
  }

  checkDescriptionLength(): void {
    if (this.description.length > this.limitDescription) {
      alert(this.translate.instant('available-internship-dialog.errors.description-too-long', { limit: this.limitDescription }));
    }
  }

  onSubmit(form: NgForm): void {
    if (!form.valid || !this.selectedCountry || !this.selectedCity) {
      this.alertService.errorKey('available-internship-dialog.errors.required-fields');
      return;
    }
    
    const dialogRef = this.dialog.open(ConfirmationnDialogComponent, {
      width: '400px',
      data: { message: this.translate.instant('available-internship-dialog.confirm-create') }
    });

    console.log(form.value)

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const dto = {
          internshipTitle: form.value.internshipsTitle,
          position: form.value.position,
          department: form.value.department,
          country: this.selectedCountry,
          email: form.value.email,
          city: this.selectedCity,
          visibility: form.value.status === 'true',
          description: this.description
        };
        this.companyService.createAvailableInternship(dto).subscribe({
          next: (res) => {
            console.log('✅ Success:', res);
            this.alertService.successKey('available-internship-dialog.success-created');
            this.dialogRef.close(true);
            window.location.reload();
          },
          error: (err) => {
            this.checkDescriptionLength();
            console.error('Error creating internship:', err);
          }
        });
      }
    });
  }
}
